import React from "react";
import VideoPlayer from "./VideoPlayer";

import Header from "./Header";
import Footer from "./Footer";
import "video.js/dist/video-js.css";
import "../styles/CollectiveReel.scss";

class CollectiveReel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: [
        {
          autoplay: false,
          controls: true,
          poster: "http://estelleleeds.com/videos/ESTELLE_COLLECTIVE.jpg",
          sources: [
            {
              src: "http://estelleleeds.com/videos/ESTELLE_COLLECTIVE.mp4",
              type: "video/mp4",
            },
          ],
        },
      ],
    };
  }
  render() {
    return (
      <div>
        <Header />
        <div className="container">
          <div className="contact-reels">
            <h1 className="serif-italic-font">Estelle Collective</h1>
            <div className="data-vjs-player">
              <VideoPlayer {...this.state.videos[0]} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default CollectiveReel;
